<template lang="pug">
  .modal.is-active
    .modal-background(@click="cerrarModal")
    .modal-content
      .box
        h5.title Autorizar Compra
        .columns
          .column.is-offset-1.is-9
            label Selecciona la opción para la compra:
        .columns
          .field
            input#radio1.is-checkradio(type='radio' v-model='optionSelected' value=1)
            label.is-size-6(for='radio1') Presupueso
            input#radio2.is-checkradio(type='radio' v-model='optionSelected' value=2)
            label.is-size-6(for='radio2') Caja Chica
            input#radio3.is-checkradio(type='radio' v-model='optionSelected' value=3)
            label.is-size-6(for='radio3') No presupuestada
        .columns
          .column
            .level-right
              .field.is-grouped
                p.control
                  a.button.is-rounded.is-danger(@click="rechazarCompra()")
                    | Rechazar
                p.control
                  a.button.is-rounded.is-black(@click="autorizarCompra()")
                    | Autorizar
</template>

<script>
  export default {
    name: 'ModalAutorizar',
    props: {
      config: {
        type: Object,
        default: ()=> {}
      }
    },
    data() {
      return {
        optionSelected: 1
      }
    },
    methods: {
      cerrarModal () {
        let obj = {
          action: 'close',
          tipoCompra: 0
        }
        this.optionSelected = 1
        this.$emit('padre:select', obj)
      },
      rechazarCompra () {
        let obj = {
          action: false,
          tipoCompra: 0
        }
        this.optionSelected = 1
        this.$emit('padre:select', obj)
      },
      autorizarCompra () {
        let obj = {
          action: true,
          tipoCompra: this.optionSelected
        }
        this.optionSelected = 1
        this.$emit('padre:select', obj)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/soporte_Componentes/components/ModalAutorizar.vue